import { loadStripe } from '@stripe/stripe-js';
import { Config } from '../Config';

export async function redirectToSubscriptionCheckout(sessionId) {
  if (!Config.stripePublishableKey) {
    throw new Error('Stripe publishable key is not configured');
  }

  const stripe = await loadStripe(Config.stripePublishableKey);
  if (!stripe) {
    throw new Error('Stripe failed to load');
  }

  const { error } = await stripe.redirectToCheckout({ sessionId });
  if (error) {
    throw error;
  }
}
